import { call, select, takeEvery } from 'redux-saga/effects'
import { addAnswer } from '../answers-slice'
import { finishScenario, startScenario } from '../scenario-slice'
import { previousStep } from '../step-slice'
import { trackScenarioStarted, trackUserIsRedirectedToResult, trackAddedStep, trackBackAction } from '../../analytics'
import { selectAnswers, selectCurrentStep } from '../selectors'
import { Answers, ScenarioStep } from '../interfaces'

export function* analyticsSaga() {
  yield takeEvery(startScenario.type, scenarioStarted)
  yield takeEvery(finishScenario.type, scenarioFinished)
  yield takeEvery(addAnswer.type, answerAdded)
  yield takeEvery(previousStep.type, previousStepTriggered)
}

function* scenarioStarted(action: ReturnType<typeof startScenario>) {
  yield call(trackScenarioStarted, action.payload)
}

function* scenarioFinished(_action: ReturnType<typeof finishScenario>) {
  const answers: Answers = yield select(selectAnswers)
  yield call(trackUserIsRedirectedToResult, answers)
}

function* answerAdded(action: ReturnType<typeof addAnswer>) {
  const answers: Answers = yield select(selectAnswers)
  const currentScenarioStep: ScenarioStep = yield select(selectCurrentStep)
  const { stepId, answerIds } = action.payload
  yield call(trackAddedStep, stepId, answerIds, answers, currentScenarioStep)
}

function* previousStepTriggered(_action: ReturnType<typeof previousStep>) {
  yield call(trackBackAction)
}
